// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"5dd40198","498":"3507e248","499":"0fe474b5","787":"3818802f","805":"c60e4be8","845":"c619e6a8"}[chunkId] + ".chunk.js";
};